module.exports = __webpack_public_path__ + "img/red_049.450f8adb.png";